core.factory('$exceptionHandler', ['$log', '$window', '$injector',
    function ($log, $window, $injector) {
        return function (exception, cause) {

            // standard behavior
            $log.error.apply($log, arguments);

            // gather data and send to server
            var applicationModel = null;
            if ($injector.has('applicationModel')) {
                applicationModel = $injector.get('applicationModel');
            }

            var userModel = null;
            if ($injector.has('userModel')) {
                userModel = $injector.get('userModel');
            }

            if (applicationModel && !applicationModel.devMode && false) { // fixme temporary disabled
                var applicationError = new ApplicationErrorVO();
                applicationError.url = $window.location.href;
                applicationError.message = exception.toString();
                applicationError.type = 'exception';
                applicationError.stackTrace = printStackTrace({ e: exception });
                applicationError.cause = ((cause) ? cause : null);
                applicationError.userId = ((userModel && userModel.currentUser) ? userModel.currentUser.id : 0);

                applicationModel.sendError(applicationError);
            }
        };
    }
]);